import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import { SearchSymbolInput } from "components/CustomComponents";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { addToWatchlist, removeFromWatchlist, loadUserWatchlist } from "reducers/user";
import axiosDefault from "layouts/authentication/api/axios";

function Watchlist() {
  const [inputText, setInputText] = useState("");
  //const [addedItems, setAddedItems] = useState([]);

  const addedItems = useSelector((state) => state.user.watchlist);
  const dispatch = useDispatch();

  const onAdd = () => {
    setInputText({ symbol: "", name: "" });
    if (inputText.name && addedItems.filter((item) => item.symbol === inputText.symbol).length === 0) {
      dispatch(addToWatchlist(inputText));
      axiosDefault().post("me/watchlist/add", inputText);
    }
  };

  const onRemove = (symbol) => {
    dispatch(removeFromWatchlist(symbol));
    axiosDefault().post("me/watchlist/remove", { symbol });
  };

  useEffect(() => {
    dispatch(loadUserWatchlist());
  }, []);

  return (
    <Card id="wishlist" style={{ overflow: "visible" }}>
      <SoftBox p={3} lineHeight={1}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5">My Watchlist</SoftTypography>
        </SoftBox>
        <SoftTypography variant="button" color="text" fontWeight="regular">
          Choose upto 10 stocks to appear under your watchlist on your dashboard.
        </SoftTypography>
        {addedItems.length > 0 && (
          <ul>
            {addedItems.map((item, index) => (
              <li key={index}>
                <SoftTypography variant="body2" style={{ display: "inline", verticalAlign: "bottom" }}>
                  {item.name} ({item.symbol})
                </SoftTypography>{" "}
                <SoftButton
                  onClick={() => onRemove(item.symbol)}
                  variant="text"
                  startIcon={<DeleteOutlineIcon />}
                  color="error"
                ></SoftButton>
              </li>
            ))}
          </ul>
        )}
      </SoftBox>
      <SoftBox></SoftBox>

      {addedItems.length < 10 && (
        <SoftBox pb={3} px={3} display="flex" alignItems="center" mb={2}>
          <SoftBox width="70%" mr={1}>
            <SearchSymbolInput inputText={inputText} setInputText={setInputText} />
          </SoftBox>
          <SoftButton onClick={onAdd} variant="outlined" color="secondary" sx={{ padding: "0.5rem 1rem" }}>
            Add
          </SoftButton>
        </SoftBox>
      )}
    </Card>
  );
}

export default Watchlist;
